import Component from '../abstracts/Component';

export default class ArticleTripleLaunchComponent extends Component {

  get COMPONENTNAME() {
    return 'ArticleTripleLaunchComponent';
  }

  get SELECTORS() {
    return {
      wrapper: '[data-wrapper]',
      left: '[data-img-left]',
      right: '[data-img-right]',
      center: '[data-img-center]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.wrapper = this.$component.querySelector(this.SELECTORS.wrapper);
    this.center = this.$component.querySelector(this.SELECTORS.center);
    this.left = this.$component.querySelector(this.SELECTORS.left);
    this.right = this.$component.querySelector(this.SELECTORS.right);
    this.header = document.querySelector('header');
    this.reverse = this.wrapper.classList.contains('reverse');

  }

    listenResize() {
        window.addEventListener('resize', () => {
            if (window.matchMedia('(min-width:768px)').matches){
            this.initObserver();
            }
        });
    }

  initObserver() {
        let options = {
          rootMargin: '0px',
          threshold: [0],
        };

        let callback = entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              let viewHeight = window.innerHeight;
              let centerHeight = this.center.offsetHeight;
              let headerHeight = this.header.offsetHeight;
              let halfViewHeight = (viewHeight - headerHeight) / 2 + headerHeight;
              let position = halfViewHeight - centerHeight / 2;


               window.addEventListener('scroll', () => {



                  let top = this.center.getBoundingClientRect().top;
                  let leftPos;
                  let rightPos;

                  if(this.reverse){
                      rightPos = (top - position) / 3;
                      leftPos = -rightPos;
                  }else{
                      leftPos = (top - position) / 3;
                      rightPos = -leftPos;
                  }

                  if (rightPos > 200) {
                      this.right.style.transform = `translateY(200%)`;
                  } else if (rightPos < -200) {
                      this.right.style.transform = `translateY(200%)`;
                  } else {
                      this.right.style.transform = `translateY(${rightPos}%)`;
                  }
                  if (leftPos > 200) {
                      this.left.style.transform = `translateY(200%)`;
                  } else if (leftPos < -200) {
                      this.left.style.transform = `translateY(200%)`;
                  } else {
                      this.left.style.transform = `translateY(${leftPos}%)`;
                  }
              });
            }
          });
        };
        let observer = new IntersectionObserver(callback, options);
        observer.observe(this.center);
  }

  render() {
    this.log('Rendering...');
    this.listenResize();
      if (window.matchMedia('(min-width:768px)').matches) {
          this.initObserver();
      }
  }
}
